import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FadeIn from "./FadeIn";
import SectionHeader from "./SectionHeader";

const CategoryCardGrid = ({ title, subtitle, cards, columns = 3, bare = false, align = "left" }) => {
  const gridClass =
    columns === 1
      ? "grid max-w-md mx-auto gap-8"
      : columns === 2
      ? "grid sm:grid-cols-2 gap-8"
      : columns === 4
      ? "grid sm:grid-cols-2 lg:grid-cols-4 gap-8"
      : columns === 5
      ? "grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8"
      : "grid sm:grid-cols-2 lg:grid-cols-3 gap-8";

  const content = (
    <>
      {(title || subtitle) && (
        <SectionHeader title={title} subtitle={subtitle} align={align} />
      )}
      <div className={`${gridClass} items-stretch`}>
          {cards.map((card, i) => (
            <FadeIn key={card.title + i} delay={i * 0.06}>
              <Link
                to={card.to}
                className="group flex flex-col ku-card overflow-hidden h-full hover:border-ku-lavender/40 border-2 border-transparent"
              >
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ku-royal/80 via-ku-royal/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <h3 className="font-display text-lg md:text-xl font-bold text-white leading-snug">
                      {card.title}
                    </h3>
                  </div>
                </div>
                {card.description && (
                  <p className="p-5 text-sm text-gray-600 font-body leading-relaxed flex-1">{card.description}</p>
                )}
                <span className="flex items-center gap-2 px-5 py-4 text-ku-violet font-accent font-semibold text-sm group-hover:gap-3 transition-all mt-auto border-t border-ku-soft/40">
                  Explore
                  <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            </FadeIn>
        ))}
      </div>
    </>
  );

  if (bare) return content;

  return (
    <section className="ku-section bg-ku-cream">
      <div className="ku-container">{content}</div>
    </section>
  );
};

export default CategoryCardGrid;
